import React from 'react'
import ProductList from './components/product-list/card'


const App = () => {
  return (
    <div>
     <ProductList/>

    </div>
  )
}

export default App